const defaultState = function () {
  return {
    mode: 0,
    returnList: false,
    tableSetList: [{}],
    tdLists: [],
    totalCount: 0,
    listIndex: -1,
    currentPage: 0,
    size: 10,
    isAndSearch: false,
    searchKeyword: '',
    searchKey: 'destination_list',
    searchConditions: {}
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getDefaultState: defaultState
}
